module.exports = __webpack_public_path__ + "static/media/GoupLeaveBigIcon.b85bfc3a.svg";